import React, { useState, useEffect, useRef } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { withNamespaces } from 'react-i18next';
import i18next from 'i18next';
import Button from 'react-bootstrap-button-loader';
import FormControl from '@material-ui/core/FormControl';

import Dialog from '@material-ui/core/Dialog';
import Slide from '@material-ui/core/Slide';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import CloseIcon from '@material-ui/icons/Close';
import AddIcon from '@material-ui/icons/Add';
import Fab from '@material-ui/core/Fab';

import MaterialResourceList from './MaterialResourceList';
import MaterialResourceForm from './MaterialResourceForm';
import * as StatusCode from '../../scripts/StatusCode';
import * as MaterialType from '../../scripts/MaterialResourceTypeMode';

import AlertAlgo from '../controls/AlertSnack'
import { isIOS } from '../../utils';
import styles from '../../styles/materialResource.module.css';

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const useStyles = makeStyles((theme) => ({
    appBar: {
        position: 'relative',
        backgroundColor: 'var(--color1) !important',
        color: 'var(--color2) !important'
    },
    toolBar: {
        marginLeft: theme.spacing(2),
        flex: 1,
    },
    titleTemplate: {
        fontSize: '20px',
        '@media (max-width: 600px)': {
            fontSize: '15px',
        }
    }
}));

export function MaterialResource(props) {
    const classes = useStyles();

    const { onLoadComplete } = props;
    const [data, setData] = useState([]);
    const [timesheetData, setTimesheetData] = useState(null);
    const [targetDate, setTargetDate] = useState(null);
    const [openMaterial, setOpenMaterial] = useState(false);
    const [materialId, setMaterialId] = useState(0);
    const [timesheetId, setTimesheet] = useState(0);
    const [typeMode, setTypeMode] = useState(null);
    const [event, setEvent] = useState({
        add: false,
        edit: false,
        reload: false,
        saved: false,
        close: false,
        type: MaterialType.Type_Material,
        id: 0,
        data: [],
        timesheetData: []
    });
    const alertRef = useRef(null);
    const [isiOS, setIsiOS] = React.useState(isIOS());

    const handleTitle = () => {
        if (props.onLoadTitle != null) {
            props.onLoadTitle(i18next.t('menu:materialResources'));
        }
    }

    useEffect(() => {
        handleTitle();
        resizeForm();
    }, []);

    useEffect(() => {
        if (props.timesheetData != null) {
            setTimesheetData(props.timesheetData);
            onLoadComplete(false);
        }
    }, [props.timesheetData]);

    useEffect(() => {
        if (props.typeMode != null) {
            setTypeMode(props.typeMode);
        }
    }, [props.typeMode]);

    useEffect(() => {
        if (event.add || event.edit || event.reload) {
            if (event.add) {
                handleOpenMaterial(0);
            } else if (event.edit) {
                handleOpenMaterial(event.id, event.data);
            }
            if (event.saved) {
                if (event.type === MaterialType.Type_Timesheet) {
                    setTimesheetData(event.timesheetData);
                    onLoadComplete(false);
               }

                showMessageSuccess(i18next.t('common:successMessage'));
            }
            if (event.close) {
                handleCloseMaterial();
            }
        }
    }, [event]);

    const handleAddButtonClick = () => {
        setEvent({ add: true });
    }

    const handleOpenMaterial = (id, material) => {
        setMaterialId(id);
        setData(material);
        setOpenMaterial(true);
    }

    const handleCloseMaterial = () => {
        setMaterialId(0);
        setOpenMaterial(false);
    }

    const showMessageSuccess = (message) => {
        alertRef.current.showMessageSuccess(message);
    }

    const showMessageError = (message) => {
        alertRef.current.showMessageError(message);
    }

    const resizeForm = () => {
        setTimeout(function () {
            const height = window.innerHeight;
            const titleBar = document.querySelector('#appBarTitle').clientHeight;
            const menu = document.querySelector('#menuFavorite').clientHeight;
            const offSet = 0;

            const customHeight = height - titleBar - menu - offSet;

            const element = document.querySelector('#listMaterialResource');

            if (element !== undefined && element !== null) {
                element.style.height = `${customHeight}px`;
            }
        }, 100);
    }


    return (
        <div id="listMaterialResource" className={styles.rootMaterialResourceBody} style={{ zIndex: '1'}}>
            <MaterialResourceList setEvent={setEvent} event={event} timesheetData={timesheetData} typeMode={typeMode} />
            <Fab color="primary" style={{ zIndex: 11001 }} aria-label="add" className={`addButtonFab ${isiOS && "addButtonFabIOS"}`} onClick={() => handleAddButtonClick()} >
                <AddIcon />
            </Fab>
            <Dialog fullScreen open={openMaterial} onClose={handleCloseMaterial} TransitionComponent={Transition} style={{ zIndex: 11001 }}>
                <div data-id="headerMaterial">
                    <AppBar className={classes.appBar}>
                        <Toolbar>
                            <IconButton edge="start" color="inherit" onClick={handleCloseMaterial} aria-label="close">
                                <CloseIcon />
                            </IconButton>
                            <Typography variant="h6" className={classes.title}>
                                {i18next.t('materialResource:form.title')}
                            </Typography>
                        </Toolbar>
                    </AppBar>
                </div>

                <div className={styles.rootEditMaterial}>
                    <MaterialResourceForm event={setEvent} id={materialId} data={data} typeMode={typeMode} timesheetData={timesheetData} />
                </div>
            </Dialog>
            <AlertAlgo ref={alertRef} />
        </div>
    );
}

export default withNamespaces(['menu', 'materialResource', 'common', 'error', 'buttons'], { wait: true })(MaterialResource);